import { CloseCircleOutlineIcon } from './CloseCircleOutlineIcon';

/**
 * author: Google
 * id EA41E6BB-A176-4E0E-896A-36F9FA5AA62F
 * name close-circle-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/close-circle-outline.svg
 * tags
 * - Form 
 */
export const MultiplyCircleOutlineIcon = CloseCircleOutlineIcon;
export default MultiplyCircleOutlineIcon